import FingerprintJS from '@fingerprintjs/fingerprintjs';

export async function getFingerprint() {
  const fp = await FingerprintJS.load({
    excludes: {
      timezone: true,
      fonts: true,
      audio: true
    }
  });
  const result = await fp.get();
  const visitorId = result.visitorId; // 32位哈希值，如 "a9d7f8e3b6c54d10"
  return visitorId;
}
